// src/utils/exportReport.js
import { jsPDF } from "jspdf";

/** Exportar CSV */
export function exportCSV(rows, stats, columns, filename, context = "Reporte") {
  const csv = [];

  // Bloque de estadísticas
  csv.push(["REPORTE DE " + context.toUpperCase()]);
  csv.push(["Fecha", new Date().toLocaleString()]);
  csv.push(["Total", stats.total]);
  if(Number.isFinite(stats.usadas))csv.push(["Usadas", stats.usadas]);
  if(Number.isFinite(stats.pendientes))csv.push(["Disponibles/Pendientes", stats.pendientes]);
  if (typeof stats.totalBs === "number") {
    csv.push([context === 'Entradas' ? 'Valor de entradas (sin consumo)' : 'Total generado', stats.totalBs]);
  }
  if (stats.sinPrecio > 0) csv.push(['Entradas sin valorar (total parcial)', stats.sinPrecio]);
  csv.push([]); // línea en blanco

  // Encabezados
  const header = columns.map(c => c.label);
  csv.push(header);

  // Filas de datos
  rows.forEach(r => {
    const line = columns.map(c => r[c.key] ?? "");
    csv.push(line);
  });

  // Convertir a CSV con separador ;
  const csvContent = csv.map(row => row.join(";")).join("\n");

  // Descargar archivo
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Exportar PDF */
export function exportPDF(rows, stats, columns, filename, context = "Reporte") {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const margin = 40;
  let y = margin;

  // Título
  doc.setFontSize(14);
  doc.text(`Reporte de ${context}`, margin, y);
  y += 18;

  // Fecha
  doc.setFontSize(10);
  doc.text(`Fecha: ${new Date().toLocaleString()}`, margin, y);
  y += 16;

  // Estadísticas
  doc.text(`Total: ${stats.total}`, margin, y); y += 14;
  if(Number.isFinite(stats.usadas)){doc.text(`Usadas: ${stats.usadas}`, margin, y); y += 14;}
  if(Number.isFinite(stats.pendientes)){doc.text(`Disponibles/Pendientes: ${stats.pendientes}`, margin, y); y += 14;}
  if (typeof stats.totalBs === "number") {
    doc.text(`${context === 'Entradas' ? 'Valor de entradas (sin consumo)' : 'Total generado'}: Bs ${stats.totalBs}`, margin, y);
    y += 18;
  }
  if (stats.sinPrecio > 0) { doc.text(`Entradas sin valorar: ${stats.sinPrecio} (total parcial)`, margin, y); y += 18; }
  y += 8;

  // Encabezados de columnas
  doc.setFontSize(10);
  const pageW = doc.internal.pageSize.getWidth();
  const colW = (pageW - margin * 2) / columns.length;
  let x = margin;

  columns.forEach(c => {
    doc.text(String(c.label), x + 2, y);
    x += colW;
  });
  y += 12;
  doc.line(margin, y, pageW - margin, y);
  y += 10;

  // Filas
  const lineH = 14;
  rows.forEach(r => {
    x = margin;
    columns.forEach(c => {
      const txt = String(r[c.key] ?? "");
      const maxChars = Math.floor((colW - 6) / 6); // limitar texto
      const clipped = txt.length > maxChars ? txt.slice(0, maxChars - 1) + "…" : txt;
      doc.text(clipped, x + 2, y);
      x += colW;
    });
    y += lineH;

    // salto de página
    if (y > doc.internal.pageSize.getHeight() - margin) {
      doc.addPage();
      y = margin;
    }
  });

  doc.save(filename);
}
